import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class BasicDropDownParagraph extends Component {
  state = {
    // The active selection's index
    activeSuggestion: 0,
    // Whether or not the suggestion list is shown
    showSuggestions: false,
    selectedOption: '',
    isUpdateDone: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const { state } = this.props;
    const { isUpdateDone } = this.state;
    if (prevProps.state !== state && !isUpdateDone) {
      if (state) {
        let selectedOption = '';
        if (state.enhanced) {
          selectedOption = 'enhanced';
        } else if (state.paddingLeft) {
          selectedOption = 'paddingLeft';
        } else if (state.firstLetterBig) {
          selectedOption = 'firstLetterBig';
        } else if (state.quote) {
          selectedOption = 'quote';
        }
        this.setState({ selectedOption, isUpdateDone: true });
      }
    }
  }

  onClick = (e) => {
    const { storeOption } = this.props;
    storeOption(e.currentTarget.innerText);
    this.setState({
      activeSuggestion: 0,
      showSuggestions: false,
      selectedOption: e.currentTarget.innerText,
    });
  };

  render() {
    const {
      onChange,
      onClick,
      state: { activeSuggestion, showSuggestions, selectedOption },
    } = this;

    const { message, suggestions, title } = this.props;

    let suggestionsListComponent;

    if (showSuggestions) {
      if (suggestions.length) {
        suggestionsListComponent = (
          <ul className="list-none mt-4 pl-0 absolute z-neg w-1/3" style={{ overflowY: 'auto', width: 'calc(300px + 1 rem)' }}>
            {suggestions.map((suggestion, index) => {
              let className;
              const list = suggestions.length;
              console.log('list', list);
              console.log('index', index);

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'cursor-pointer';
              }

              if (index === list - 1) {
                className = 'rounded-b-xl';
              }

              if (index === 0) {
                className = 'pt-6';
              }

              return (
                <li className={`${className} p-2 pl-7 text-black bg-white uppercase cursor-pointer`} key={suggestion} onClick={onClick}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions mt-2">
            <em>{message}</em>
          </div>
        );
      }
    }

    return (
      <div className="flex flex-col font-americaMonoRegular text-xs ">
        <button
          type="button"
          onClick={() => {
            this.setState({ showSuggestions: !showSuggestions });
          }}
          className=" rounded-full p-2 bg-white text-black outline-none"
        >
          {showSuggestions ? (
            <div className="flex justify-between items-center pl-4 uppercase">
              {selectedOption || title}
              <span className="font-icon icon-arrow-up font-bold pr-1 text-xxs" />
            </div>
          ) : (
            <div className="flex justify-between items-center pl-4 uppercase">
              {selectedOption || title}
              <span className="font-icon icon-arrow-down font-bold pr-1 text-xxs" />
            </div>
          )}
        </button>
        {/* <input type="text" onChange={onChange} value={userInput} className="mt-2 rounded-full border-1 p-2 bg-white text-black outline-none" /> */}
        {suggestionsListComponent}
      </div>
    );
  }
}

BasicDropDownParagraph.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  storeOption: PropTypes.func.isRequired,
  state: PropTypes.shape(),
};

BasicDropDownParagraph.defaultProps = {
  state: {},
};

BasicDropDownParagraph.defaultProps = {};

export default BasicDropDownParagraph;
